import { PlayerComparisonRepository } from './playerComparisonRepository';
import {AddOnSearchReloadOperation} from '../search';

const additionSelector = '[data-ndc-matchmaker-compare-add]';
const additionIdDataKey = 'ndc-matchmaker-compare-add';

const removalSelector = '[data-ndc-matchmaker-compare-remove]';
const removalIdDataKey = 'ndc-matchmaker-compare-remove';

const clearAllSelector = '[data-ndc-matchmaker-compare-clear]';


bindCompareActions($('body'));

AddOnSearchReloadOperation(bindCompareActions);

export function bindCompareActions(scope: JQuery<HTMLElement>) {
    bindAdditionAction(scope);
    bindRemovalAction(scope);
    bindClearAllAction(scope);
}

function bindAdditionAction(scope: JQuery<HTMLElement>) {
    scope.find(additionSelector).each((index, element) => {
        const jqueryElement = $(element);

        const idToAdd: string = jqueryElement.data(additionIdDataKey).toString();

        if (PlayerComparisonRepository.isInComparisonList(idToAdd)){
            disableElement(jqueryElement);
            return;
        }

        jqueryElement.click((e) => {
            e.preventDefault();
            const initialComparisonNumber = PlayerComparisonRepository.getComparisons().length;
            PlayerComparisonRepository.addComparison(idToAdd);
            const afterwardsComparisonNumber = PlayerComparisonRepository.getComparisons().length;

            if (afterwardsComparisonNumber > initialComparisonNumber) {
                disableElement(jqueryElement);
            }
        });
    });
}

function disableElement(element: JQuery<HTMLElement>)
{
    element.addClass("btn-disabled");
    element.removeAttr("href");
}

function bindRemovalAction(scope: JQuery<HTMLElement>) {
    scope.find(removalSelector).each((index, element) => {
        const jqueryElement = $(element);

        const idToAdd: string = jqueryElement.data(removalIdDataKey).toString();

        jqueryElement.click((e) => {
            e.preventDefault();
            PlayerComparisonRepository.removeComparison(idToAdd);
        });
    });
}

function bindClearAllAction(scope: JQuery<HTMLElement>) {
    scope.find(clearAllSelector).each((index, element) => {
        const jqueryElement = $(element);
        jqueryElement.click((e) => {
            e.preventDefault();
            PlayerComparisonRepository.clearAllComparisons();
        });
    });
}
